import { jwtDecode } from 'jwt-decode';
import { useRef } from 'react';

import { PINWHEEL_SCRIPT } from '@perpay-web/fintech/constants/urls';
import { useMountAndUnmount } from '@perpay-web/hooks/useMountAndUnmount';
import { reportError } from '@perpay-web/utils/errorHandlers';
import { loadThirdPartyScript } from '@perpay-web/utils/scriptUtils';

const PINWHEEL_MODAL_INVALID_USER_INPUT_ERROR_TYPE = 'invalidUserInput';

const PINWHEEL_PRIME_ELIGIBLE_EXPERIENCE_EVENT_NAME = 'Prime Eligible';

const PINWHEEL_MODAL_NON_FATAL_ERROR_TYPES = [
    PINWHEEL_MODAL_INVALID_USER_INPUT_ERROR_TYPE,
];

function installPinwheelScript() {
    return loadThirdPartyScript(PINWHEEL_SCRIPT).then(() => window.Pinwheel);
}

const PinwheelModal = ({
    linkToken,
    onSuccess,
    onErrorExit,
    onNonErrorExit,
    onEvent,
    onMount,
}) => {
    const pinwheelRef = useRef(null);
    const tokenId = jwtDecode(linkToken).data.token_id;
    const isStandardFlow = jwtDecode(linkToken).data.skip_intro_screen;

    useMountAndUnmount(() => {
        onMount();
        installPinwheelScript().then((Pinwheel) => {
            pinwheelRef.current = Pinwheel;
            Pinwheel.open({
                linkToken,
                onSuccess: () => onSuccess(),
                onExit: (error) => {
                    // If there is no error or if the error is non-fatal, call onNonErrorExit()
                    if (
                        error === undefined ||
                        PINWHEEL_MODAL_NON_FATAL_ERROR_TYPES.includes(
                            error.type,
                        )
                    ) {
                        onNonErrorExit();
                    } else {
                        onErrorExit(error);
                    }
                },
                onEvent: (eventName, eventPayload) => {
                    onEvent(eventName, {
                        ...eventPayload,
                        tokenId,
                        ...(!isStandardFlow && {
                            experience:
                                PINWHEEL_PRIME_ELIGIBLE_EXPERIENCE_EVENT_NAME,
                        }),
                    });
                },
            });
        });
        return () => {
            if (pinwheelRef.current) {
                try {
                    // The pinwheel iframe may already have been closed
                    pinwheelRef.current.close();
                } catch (error) {
                    reportError(error);
                }
            }
        };
    });
    return null;
};

export default PinwheelModal;
